// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1ClsO","cell":"ColumnAccessor_cell__2TVKd","firstCellAccent":"ColumnAccessor_firstCellAccent__1-2eC"};